import MasterReferencesModel from '../Apis/MasterReferences.js'
import Controller from './Controller.js';

export default class MasterReferencesController extends Controller {

    constructor() {
        super(new MasterReferencesModel());
    }


}